import React from 'react';
import { Text, mergeClassNames } from '@clockout-dev/design-elements';
import { NotificationSeverityPill } from '../../notificationSeverityPill';
import RelativeTime from '../../../reports/elements/RelativeTime';
import styles from '../styles/notificationsMenu.module.scss';

/**
 * Floating menu rendered inside the header bell's Popover: the latest five
 * notifications, summarized, plus a CTA to /notifications. Presentational —
 * items, state and handlers come from HeaderController.
 */
function NotificationsMenu({ items, loading, error, unreadCount, onItemClick, onViewAll }) {
    const rows = items || [];

    return (
        <div className={styles.menu}>
            <div className={styles.menuHeader}>
                <Text as="span" size="s" className={styles.menuTitle}>
                    Notifications
                </Text>
                {unreadCount > 0 ? (
                    <Text as="span" size="xs" className={styles.menuUnread}>
                        {unreadCount} unread
                    </Text>
                ) : null}
            </div>

            {loading ? (
                <Text as="span" size="xs" className={styles.menuState}>
                    Loading…
                </Text>
            ) : error ? (
                <Text as="span" size="xs" className={styles.menuState}>
                    Couldn't load notifications.
                </Text>
            ) : rows.length === 0 ? (
                <Text as="span" size="xs" className={styles.menuState}>
                    You're all caught up.
                </Text>
            ) : (
                <ul className={styles.menuList}>
                    {rows.map((item) => (
                        <li key={item.id}>
                            <button
                                type="button"
                                className={mergeClassNames([
                                    styles.menuItem,
                                    !item.readAt ? styles.menuItemUnread : null,
                                ])}
                                onClick={() => onItemClick(item)}
                            >
                                <span className={styles.menuItemDot} aria-hidden="true" />
                                <span className={styles.menuItemBody}>
                                    <span className={styles.menuItemTop}>
                                        <NotificationSeverityPill severity={item.severity} />
                                        <RelativeTime value={item.createdAt} className={styles.menuItemTime} />
                                    </span>
                                    <Text as="span" size="xs" className={styles.menuItemTitle}>
                                        {item.title || '—'}
                                    </Text>
                                    {item.body ? (
                                        <Text as="span" size="xs" className={styles.menuItemText} title={item.body}>
                                            {item.body}
                                        </Text>
                                    ) : null}
                                </span>
                            </button>
                        </li>
                    ))}
                </ul>
            )}

            <button type="button" className={styles.menuCta} onClick={onViewAll}>
                <Text as="span" size="xs" className={styles.menuCtaText}>
                    View all notifications
                </Text>
            </button>
        </div>
    );
}

export default NotificationsMenu;
